import React, { useEffect, useRef } from 'react';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Table, Row, Col, Card, CardBody, Container } from 'reactstrap';
import { TablePagination } from '../../Components/Pagination'
import { getBanners, updateBanners } from '../../API/Backend';
import { showToast } from '../../Components/Toast';
import Skeleton from "react-loading-skeleton";
import Image from '../../Components/Image'


const Banners = () => {
  const [banners, setBanners] = useState([]);
  const [loading, setLoading] = useState(false);
  const [update, setUpdate] = useState(0);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(0);
  const [keyword, setKeyword] = useState("");
  const keywordRef = useRef("");

  useEffect(() => {
    fetchBanners();
  }, [update])

  const fetchBanners = (limit = 10, offset = 0, keyword = "") => {
    setLoading(true)
    setBanners([])
    getBanners({ limit: limit, offset: offset, ...(keyword && keyword.length && { search: keyword }) }).then(({ data }) => {
      if (data.data) {
        // console.log('banners', data)
        setBanners(data.data ? data.data.banners : [])
        setCount(data.data ? data.data.count : 0)
      }
      else {
        showToast("error", "Request Failed", data.message)
      }
      setLoading(false)
    }).catch((err) => {
      showToast("error", "Request Failed", err.message)
      setLoading(false)
    })
  }

  const onPaginationChange = (currentPage) => {
    if (page !== currentPage) {
      setPage(currentPage);
      fetchBanners(limit, limit * (currentPage - 1), keyword)
    }
  }

  const searchByKeyword = (e) => {
    e.preventDefault();
    setKeyword(keywordRef.current.value);
    fetchBanners(limit, 0, keywordRef.current.value)
  }

  const toggleStatus = (bannerId, status) => {
    updateBanners({ isActive: status }, bannerId).then((data) => {
      if (data) {
        setUpdate(prev => prev + 1)
      }
      else {
        showToast("error", "Request Failed", data.message)
      }
    }).catch((err) => {
      showToast("error", "Request Failed", err.message)
    })
  };
  return (
    <Container fluid>
      <Row>
        <Col>
          <h5 className="page-title">Banners</h5>
          <Card>
            <CardBody>
              <Row className="mb-3">
                <Col md="12">
                  <div className='d-flex align-items-center gap-5'>
                    <div className='table-size-container'>
                      <span>Showing</span>
                      <select className='table-size-control' value={limit} onChange={(e) => { setLimit(Number(e.target.value)); fetchBanners(Number(e.target.value), 0, "") }}>
                        <option value="10">10</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                      </select>
                      <span>entries</span>
                    </div>
                    <div className="table-search-box">
                      <input type="search" id="customSearch" placeholder="Search Here..." ref={keywordRef} onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); searchByKeyword(e); } }} />
                      <button disabled={loading} onClick={(e) => { searchByKeyword(e) }}><i className="ri-search-line"></i></button>
                    </div>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Table>
                    <thead>
                      <tr>
                        <th>Banner</th>
                        <th>Banner Name</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        loading ?
                          [...Array(15)].map((a, i) => {
                            return <tr key={i}>
                              <td><div><Skeleton height={40} width={80} className='me-2' /></div></td>
                              <td><Skeleton height={12} width={80} /></td>
                              <td><Skeleton height={20} width={60} /></td>
                              <td><Skeleton height={30} width={60} /></td>
                            </tr>
                          }) :
                          !banners.length ?
                            <tr><td colSpan="4" className="text-center fs-12 fw-600"><span className="d-flex align-items-center justify-content-center"><i className="ri-error-warning-line text-danger fs-22 fw-300 me-2"></i> No banners found</span></td></tr> :
                            banners.map((banner, i) => (
                              <tr key={banner._id}>
                                <td>
                                  <Image src={`${process.env.REACT_APP_IMAGE_DIRECTORY}/${banner.image}`} alt="Banner" className='me-2' height='40px' width='70px' objectFit='cover' />
                                </td>
                                <td>{banner.title}</td>
                                <td>
                                  <div className={`pill-toggle ${banner.isActive ? 'active' : ''}`} onClick={() => toggleStatus(banner._id, !banner.isActive)}>
                                    <div className="pill-label">{banner.isActive ? 'Active' : 'Inactive'}</div>
                                    <div className="pill-circle"></div>
                                  </div>
                                </td>
                                <td>
                                  <Link to={'/banners/edit/' + banner._id} className='btn btn-rounded btn-outline-secondary btn-small'><i className="ri-edit-line"></i> Edit</Link>
                                </td>
                              </tr>
                            ))}
                    </tbody>
                  </Table>
                </Col>
              </Row>
              <TablePagination limit={limit} page={page} currentRecords={banners.length} total={count} loading={false} onPaginationChange={(p) => onPaginationChange(p)} />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}
export default Banners